import React, { useEffect, useState } from "react";
import restApi from "../../services/ApiServices/RestApi";
import pkg from "../../../package.json"; // adjust path if needed

const SettingsContent = () => {
  const [backendVersion, setBackendVersion] = useState("...");
  const [backendBuild, setBackendBuild] = useState("...");
  // const [lastUpdated, setLastUpdated] = useState("...");

  const frontendVersion = pkg.version || "unknown";
  const frontendBuild = pkg.build || pkg.BuildVersion || "-";

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await restApi.get("general/setings");
        const { version, build } = res.data;
        setBackendVersion(version || "unknown");
        setBackendBuild(build || "-");
        // setLastUpdated(lastUpdated || "-");
      } catch (err) {
        console.error("Error fetching backend version info:", err);
        setBackendVersion("error");
        setBackendBuild("error");
        // setLastUpdated("-");
      }
    };

    fetchSettings();
  }, []);

  return (
    <div className="space-y-[34px] text-white font-Inter text-[14px] leading-[18px] font-normal">
      {/* General Info */}
      <div className="flex items-start gap-8 mt-[34px]">
        <div className="min-w-[180px]">
          <span className="text-[14px] font-normal text-white">
            General information
          </span>
        </div>
        <div className="flex-1 space-y-3">
          <p>
            On this page, you can find essential information about the software
            version and other relevant details:
          </p>
          <p>
            <span className="font-normal">Frontend Version:</span> Version{" "}
            {frontendVersion}
          </p>
          <p>
            <span className="font-normal">Backend Version:</span> Version{" "}
            {backendVersion}
          </p>
          <p>
            <span className="font-normal">Terms of Use:</span>{" "}
            <a
              href="#"
              className="text-blue-500 underline"
              onClick={(e) => {
                e.preventDefault();
                window.globalToast?.add({
                  type: "info",
                  title: "Terms of Use",
                  message: "This would redirect to the Terms of Use page.",
                });
              }}>
              Click here
            </a>{" "}
            to view our Terms and Conditions and Privacy Policy.
          </p>
          <p>
            <span className="font-normal">Technical Support:</span> For
            technical assistance, please reach out to our support team using the
            contact information below.
          </p>
        </div>
      </div>

      <hr className="border-[#999999]" />

      {/* About Genesis */}
      <div className="flex items-start gap-8">
        <div className="min-w-[180px]">
          <span className="text-[14px] font-normal text-white">
            About Genesis
          </span>
        </div>
        <div className="flex-1">
          <p>
            Genesis Medical is a pioneering company in the field of AI-driven
            radiology, focusing on early detection of lung cancer. Our system is
            designed to assist radiologists with precise and comprehensive
            identification of lung nodules, using advanced technology integrated
            with CT images. Our mission is to improve patient outcomes by
            enabling earlier and more accurate diagnoses.
          </p>
        </div>
      </div>

      <hr className="border-[#999999]" />

      {/* Contact Us */}
      <div className="flex items-start gap-8">
        <div className="min-w-[180px]">
          <span className="text-[14px] font-normal text-white">Contact Us</span>
        </div>
        <div className="flex-1">
          <p className="mb-4">
            If you have any further questions or need assistance, we are here to
            help!
          </p>
          <div className="space-y-1">
            <p>
              <span className="font-normal">Email:</span>{" "}
              support@genesismedical.com
            </p>
            <p>
              <span className="font-normal">Phone:</span> 1-800-123-456
            </p>
            <p>
              <span className="font-normal">Address:</span> 18 HaBarzel Street,
              Tel Aviv, Israel
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsContent;
